import React from "react";
import { Alert, Button, Input, InputGroup, InputGroupText } from "reactstrap";
import axios from "axios";
import { baseUrl } from "..";
import { Navigate } from "react-router-dom";
import Logo from "../Assets/Logo.svg";
import BackgroundImage from "../Assets/Login.jpg";

class LoginPage extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
            passwordType: "password",
            messageColor: "success",
            isLaptop: window.matchMedia("(min-width: 1024px)").matches, // Check initial screen size
            isMobile: window.matchMedia("(max-width: 768px)").matches,          
            message: "",
            isLoading: false
        }
    }
    async componentDidMount() {
        this.mediaQuery = window.matchMedia("(min-width: 1024px)");
        this.mediaQuery.addEventListener("change", this.handleResize);
        this.mediaQueryList = window.matchMedia("(max-width: 768px)");
        this.mediaQueryList.addEventListener("change", this.updateScreenSize);
    }
    handleResize = (event) => {
        this.setState({ isLaptop: event.matches });
      };
    
      updateScreenSize = (event) => {
          this.setState({ isMobile: event.matches });
        };
    render() {
        const onChange = (e) => {
            const { name, value } = e.target
            this.setState({ [name]: value })
        }
        const changePasswordType = () => {
            if (this.state.passwordType === "password")
                this.setState({ passwordType: "text" })
            else
                this.setState({ passwordType: "password" })
        }

        const onSubmit = () => {
            const { password, email } = this.state
            const data = { password, email }
            this.setState({ isLoading: true })
            axios.post(`${baseUrl}/auth/login`, data).then(result => {
                this.setState({ messageColor: "success", isLoading: false, message: "Login Successful. Redirecting.." })
                setTimeout(() => {
                    this.setState({ message: "" })
                }, 3000)
                localStorage.setItem("token", result.data.token)
                window.location.reload()
            }).catch(err => {
                console.log(err.message)
                this.setState({ messageColor: "danger", isLoading: false, message: err.message })
                setTimeout(() => {
                    this.setState({ message: "" })
                }, 3000)
            })
        }

        const forgotPassword = () => {
            const { email } = this.state
            if (email === "") {
                this.setState({ messageColor: "danger", message: "Please enter email to receive reset password link" })
                setTimeout(() => {
                    this.setState({ message: "" })
                }, 3000)
            }
            else {
                axios.post(`${baseUrl}/auth/forgot-password`, { email }).then(result => {
                    this.setState({ messageColor: "success", message: result.data.message })
                    setTimeout(() => {
                        this.setState({ message: "" })
                    }, 3000)
                }).catch(err => {
                    console.log(err.message)
                    this.setState({ messageColor: "danger",  message: err.message })
                    setTimeout(() => {
                        this.setState({ message: "" })
                    }, 3000)
                })
            }
        }

        const isDisabled = !(this.state.email && this.state.password) || this.state.isLoading

        if (localStorage.getItem("token"))
            return <Navigate to="/reservation" />
        
        return (
            
            <div className="row row-cols-md-2 row-cols-1 g-0">
                {this.state.isLaptop && (
                    <>
                <div className="col-md-5">
                    <div className="p-5 bg-primary-o" style={{ height: "100vh",
                        backgroundImage: `url(${BackgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat", }}>
                        <img
                            src={Logo}
                            alt="Hostel-Co"
                            className="d-none d-md-inline-block"
                            style={{ height: "40px" }}
                        />
                        
                    </div>
                </div>
                <div className="col-md-7">
                    <div style={{ height: "100vh", width: "50%", margin: "auto" }} className="d-flex flex-column align-items-center justify-content-center gap-3">
                        <div className="text-center" >
                            <div className="text-black h2 fw-bold" style={{textShadow: "1px 1px 4px rgba(0, 0, 0, 0.4)"}}>The Hostel Co Extranet</div>
                            <div className="text-black h5" style={{textShadow: "1px 1px 4px rgba(0, 0, 0, 0.4)"}}>Accelerate your Hostel Business</div>
                        </div>
                        <div className="text-tertiary-o h1 mb-5">Login</div>
                        <Input placeholder="Email" onChange={onChange} value={this.state.email} name="email" />
                        <InputGroup className="border rounded">
                            <Input className="border-0" placeholder="Password" onChange={onChange} value={this.state.password} name="password" type={this.state.passwordType} />
                            <InputGroupText style={{ cursor: "pointer" }} onClick={changePasswordType} className="bg-transparent border-0">
                                {this.state.passwordType === "password" ? <i class="bi bi-eye-fill"></i> : <i class="bi bi-eye-slash-fill"></i>}
                            </InputGroupText>
                        </InputGroup>
                        <div className="text-end w-100 mb-3">
                            <a href="#" onClick={forgotPassword}>
                                Forgot Password?
                            </a>
                        </div>
                        <Button disabled={isDisabled} onClick={onSubmit} className="px-5 bg-primary-o">
                            {this.state.isLoading ? "Loading.." : "Login"}
                        </Button>
                        {this.state.message &&
                            <Alert color={this.state.messageColor}>
                                {this.state.message}
                            </Alert>
                        }
                    </div>
                </div>
                </>
                )}
                {this.state.isMobile && (
                    <>
                <div className="col-md-5">
                    <div className="p-5 bg-primary-o" style={{ height: "40vh",
                        backgroundImage: `url(${BackgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat", }}>
                        <img
                            src={Logo}
                            alt="Hostel-Co"
                            className="d-none d-md-inline-block"
                            style={{ height: "40px" }}
                        />
                        
                    </div>
                        <div className="text-center mt-2" >
                            <div className="text-black h2 fw-bold" style={{textShadow: "1px 1px 4px rgba(0, 0, 0, 0.4)"}}>The Hostel Co Extranet</div>
                            <div className="text-black h6" style={{textShadow: "1px 1px 4px rgba(0, 0, 0, 0.4)"}}>Accelerate your Hostel Business</div>
                        </div>
                    <div style={{ height: "50vh", width: "50%", margin: "auto" ,marginTop: "2rem" }} className="d-flex flex-column align-items-center gap-3">
                        <div className="text-tertiary-o h1 mb-5">Login</div>
                        <Input placeholder="Email" onChange={onChange} value={this.state.email} name="email" />
                        <InputGroup className="border rounded">
                            <Input className="border-0" placeholder="Password" onChange={onChange} value={this.state.password} name="password" type={this.state.passwordType} />
                            <InputGroupText style={{ cursor: "pointer" }} onClick={changePasswordType} className="bg-transparent border-0">
                                {this.state.passwordType === "password" ? <i class="bi bi-eye-fill"></i> : <i class="bi bi-eye-slash-fill"></i>}
                            </InputGroupText>
                        </InputGroup>
                        <div className="text-end w-100 mb-3">
                            <a href="#" onClick={forgotPassword}>
                                Forgot Password?
                            </a>
                        </div>
                        <Button disabled={isDisabled} onClick={onSubmit} className="px-5 bg-primary-o">
                            {this.state.isLoading ? "Loading.." : "Login"}
                        </Button>
                        {this.state.message &&
                            <Alert color={this.state.messageColor}>
                                {this.state.message}
                            </Alert>
                        }
                    </div>
                </div>
                </>
                )}
            </div>
        )
    }
}

export default LoginPage

// Account Credentials: test@gmail.com and Test1234